import { DatePicker, Button } from "antd";
import {
  bulgarianLocaleDaysAndMonths,
  bulgarianLocalCalandarText,
} from "../../utils/utility";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import ticketsActions from "../../redux/ticket/actions";
const DateSearchForm = ({
  startDate,
  setStartDate,
  startTime,
  setStartTime,
  endDate,
  setEndDate,
  endTime,
  setEndTime,
  combinedStartDateTime,
  combinedEndDateTime,
  heading,
}) => {
  const dispatch = useDispatch();
  const { getReservationInfoByPeriod } = ticketsActions;

  const { adminToken, companies } = useSelector((state) => state.mainReducer);
  return (
    <>
      <h1
        style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}
      >
        {heading}
      </h1>
      <div className="search-reservation-by-period-container">
        <div className="search-inputs-container">
          <div className="search-reservation-input-item">
            <label
              style={{ marginBottom: "5px", fontSize: "13px", color: "#000" }}
            >
              Начална дата
            </label>
            <DatePicker
              style={{ height: "50px", width: "100%" }}
              format="DD/MM/YYYY"
              value={startDate}
              onChange={(date) => setStartDate(date)}
              locale={{
                lang: bulgarianLocalCalandarText,
                dayjsLocale: bulgarianLocaleDaysAndMonths,
              }}
              placeholder="Начална дата"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ marginBottom: "5px", fontSize: "13px", color: "#000" }}
            >
              Начален час
            </label>
            <DatePicker
              style={{ height: "50px", width: "100%" }}
              picker="time"
              format="HH:mm"
              value={startTime}
              onChange={(time) => setStartTime(time)}
              placeholder="Начален час"
            />
          </div>
        </div>
        <div className="search-inputs-container">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ marginBottom: "5px", fontSize: "13px", color: "#000" }}
            >
              Крайна дата
            </label>
            <DatePicker
              style={{ height: "50px", width: "100%" }}
              format="DD/MM/YYYY"
              value={endDate}
              onChange={(date) => setEndDate(date)}
              locale={{
                lang: bulgarianLocalCalandarText,
                dayjsLocale: bulgarianLocaleDaysAndMonths,
              }}
              placeholder="Крайна дата"
            />
          </div>
          <div className="search-reservation-input-item">
            <label
              style={{ marginBottom: "5px", fontSize: "13px", color: "#000" }}
            >
              Краен час
            </label>
            <DatePicker
              style={{ height: "50px", width: "100%" }}
              picker="time"
              format="HH:mm"
              value={endTime}
              onChange={(time) => setEndTime(time)}
              placeholder="Краен час"
            />
          </div>
        </div>
        <Button
          size="large"
          className="custom-button search-reservations-by-period-button"
          type="primary"
          onClick={() =>
            dispatch(
              getReservationInfoByPeriod(
                adminToken,
                companies[0]?.id,
                combinedStartDateTime.unix().toString(),
                combinedEndDateTime.unix().toString()
              )
            )
          }
        >
          Търсене
        </Button>
      </div>
    </>
  );
};

export default DateSearchForm;
